'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var coreRenderer = require('@tempi/core-renderer');

const getSizeWithUnit = (value) => {
  if (typeof (value == null ? void 0 : value.size) === "number") {
    return `${value == null ? void 0 : value.size}${(value == null ? void 0 : value.unit) || coreRenderer.UnitEnum.pixel}`;
  }
};

exports.getSizeWithUnit = getSizeWithUnit;
